// import { Link } from '@atoms/*';
import { FunctionComponent } from 'react';
import happyFace from '@assets/happy-face.svg';
import straightFace from '@assets/straight-face.svg';
import sadFace from '@assets/sad-face.svg';
import { Link } from 'react-router-dom';

export interface FeedbackLinkProps {
  url?: string;
}

export const FeedbackLink: FunctionComponent<FeedbackLinkProps> = ({ url }) => {
  return (
    <div className="border-brand-primary w-full max-w-xs rounded-md border-l-4 px-4 pb-4 pt-2 shadow-lg">
      <Link
        to="https://websurveys2.govmetric.com/theme/gm/9990019"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="mb-2 flex items-center justify-between">
          <span className="text-action-link hover:text-action-link-hover focus:text-action-link-hover font-medium underline underline-offset-1">
            Give feedback
          </span>
          <div className="flex gap-x-1">
            <img src={happyFace} alt="Happy face" />
            <img src={straightFace} alt="Straight face" />
            <img src={sadFace} alt="Sad face" />
          </div>
        </div>
        <p>Help us enhance the service by completing our short survey.</p>
      </Link>
    </div>
  );
};
